import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const StepPriceGuidance = ({ data, onNext, onBack }) => {
  const { t } = useLanguage();
  const [price, setPrice] = useState(data?.price || '');
  const [showGuidance, setShowGuidance] = useState(false);

  const suggestedRange = {
    min: 1750000,
    max: 1850000,
    confidence: 85
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onNext({ price });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{t('priceGuidanceTitle')}</h2>
        <p className="text-muted-foreground">{t('priceGuidanceDesc')}</p>
      </div>

      <div className="space-y-6">
        {!showGuidance ? (
          <div className="text-center py-8">
            <Icon name="DollarSign" size={64} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-foreground mb-2">{t('getPriceGuidance')}</h3>
            <p className="text-muted-foreground mb-6">
              {t('getPriceGuidanceDesc')}
            </p>
            <Button
              type="button"
              variant="default"
              onClick={() => setShowGuidance(true)}
              iconName="TrendingUp"
            >
              {t('showPriceGuidance')}
            </Button>
          </div>
        ) : (
          <>
            <div className="bg-primary/10 border border-primary/20 rounded-lg p-6">
              <div className="flex items-center gap-2 mb-4">
                <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
                <h3 className="font-semibold text-foreground">{t('suggestedPriceRange')}</h3>
              </div>
              <div className="text-center mb-4">
                <p className="text-3xl font-bold text-primary">
                  ${suggestedRange?.min?.toLocaleString()} - ${suggestedRange?.max?.toLocaleString()}
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                  {suggestedRange?.confidence}% {t('confidenceBasedOnMarket')}
                </p>
              </div>
              <div className="space-y-2 text-sm text-muted-foreground">
                <p>• Based on 12 comparable sales in the area</p>
                <p>• Current market conditions: Strong buyer demand</p>
                <p>• Average days on market: 28 days</p>
              </div>
            </div>

            <Input
              label={data?.listingType === 'rent' ? t('weeklyRent') : t('askingPrice')}
              type="number"
              placeholder="Enter amount"
              value={price}
              onChange={(e) => setPrice(e?.target?.value)}
              required
            />
          </>
        )}
      </div>

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack} iconName="ArrowLeft">{t('back')}</Button>
        {showGuidance && price && (
          <Button type="submit" variant="default" iconName="ArrowRight" iconPosition="right">{t('continue')}</Button>
        )}
      </div>
    </form>
  );
};

export default StepPriceGuidance;